export class AppGlueError extends Error {
    statusCode: number = 400;

    constructor(message: string, statusCode: number = 400) {
        super(message);
        this.message = message;
        this.statusCode = statusCode;
    }
}
